import * as React from "react";

const DeleteIcon = (props: { disabled?: boolean } & JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  const { disabled = false } = props;
  if (disabled)
    return (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          d="M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z"
          fill="black"
          fillOpacity="0.38"
        />
      </svg>
    );
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  );
};
export default DeleteIcon;
